// src/components/PrivacyPolicyModal/content/fr.tsx
import { FC } from 'react';

const FrContent: FC = () => (
  <>
    <h2>POLITIQUE DE CONFIDENTIALITÉ - THE PATCH</h2>
    <p>
      <strong>Dernière mise à jour : 27/01/2026</strong>
    </p>
    <p>
      La présente politique de confidentialité a pour objet d&apos;expliquer de manière claire et transparente comment la société <strong>The Patch</strong> (« nous », « notre », « nos ») collecte,
      utilise, conserve et protège les données personnelles des utilisateurs (« vous ») dans le cadre de l&apos;utilisation de la plateforme The Patch (les « Services »).
    </p>
    <p>En utilisant The Patch, vous acceptez les pratiques décrites ci-dessous.</p>
    <p>Si vous n&apos;êtes pas d&apos;accord avec cette politique, nous vous invitons à ne pas utiliser nos Services.</p>
    {/* TODO(brand): keep prepwise.fr email temporarily; update after mailbox migration. */}
    <p>
      Pour toute question : <strong>contact@prepwise.fr</strong>
    </p>

    <hr />

    <h3>1. Résumé des points clés</h3>
    <ul>
      <li>Nous collectons uniquement les données nécessaires au fonctionnement et à l&apos;amélioration de The Patch</li>
      <li>
        Nous ne traitons <strong>aucune donnée sensible</strong> au sens du RGPD
      </li>
      <li>Vous conservez le contrôle total sur vos données (accès, suppression, opposition)</li>
      <li>
        Les contenus sont utilisés pour <strong>vous entraîner</strong>, <strong>vous proposer des offres pertinentes</strong>, et <strong>améliorer le service</strong>
      </li>
    </ul>

    <hr />

    <h3>2. Quelles données collectons-nous ?</h3>
    <h4>2.1 Données que vous nous fournissez directement</h4>
    <p>Lorsque vous utilisez The Patch, vous pouvez être amené à nous transmettre :</p>
    <ul>
      <li>Identité : nom, prénom, adresse email</li>
      <li>Données de compte : identifiant, mot de passe (chiffré)</li>
      <li>Données de candidature : CV, lettres de motivation, descriptions de postes ciblés</li>
      <li>Données d&apos;entraînement : réponses écrites, réponses orales (fichiers audio), feedbacks et scores générés</li>
      <li>Historique d&apos;utilisation de la plateforme</li>
    </ul>
    <p>Ces données sont nécessaires pour fournir les fonctionnalités proposées.</p>

    <h4>2.2 Données collectées automatiquement</h4>
    <p>Lors de votre navigation, certaines données techniques peuvent être collectées :</p>
    <ul>
      <li>adresse IP</li>
      <li>type de navigateur et d&apos;appareil</li>
      <li>système d&apos;exploitation</li>
      <li>données de navigation et d&apos;usage</li>
    </ul>
    <p>Ces informations servent à la sécurité, au bon fonctionnement et à l&apos;amélioration du service.</p>

    <hr />

    <h3>3. À quelles fins utilisons-nous vos données ?</h3>
    <p>Nous traitons vos données personnelles pour :</p>
    <ul>
      <li>créer et gérer votre compte utilisateur</li>
      <li>analyser votre CV et vos lettres de motivation</li>
      <li>générer des CV personnalisés</li>
      <li>générer des lettres de motivation personnalisées</li>
      <li>simuler des entretiens d&apos;embauche et fournir des feedbacks</li>
      <li>vous proposer des offres d&apos;emploi adaptées à votre profil</li>
      <li>permettre, le cas échéant, une candidature directe via The Patch</li>
      <li>améliorer la qualité, la pertinence et la performance de nos services</li>
      <li>assurer la sécurité et prévenir les usages frauduleux</li>
      <li>respecter nos obligations légales</li>
    </ul>
    <p>
      <strong>Important :</strong> The Patch est un outil d&apos;aide à la préparation. Les analyses, scores et recommandations ne constituent{' '}
      <strong>ni une décision de recrutement, ni une garantie d&apos;embauche</strong>.
    </p>

    <hr />

    <h3>4. Bases légales du traitement (RGPD)</h3>
    <p>Conformément au RGPD, les traitements reposent sur :</p>
    <ul>
      <li>
        votre <strong>consentement</strong> (ex. création de compte, données fournies)
      </li>
      <li>
        l&apos;<strong>exécution du contrat</strong> (fourniture des services The Patch)
      </li>
      <li>
        notre <strong>intérêt légitime</strong> (amélioration du service, sécurité)
      </li>
      <li>
        le respect d&apos;<strong>obligations légales</strong>
      </li>
    </ul>
    <p>Vous pouvez retirer votre consentement à tout moment.</p>

    <hr />

    <h3>5. Partage des données avec des tiers</h3>
    <p>Vos données peuvent être partagées uniquement avec :</p>
    <ul>
      <li>des prestataires techniques (hébergement, cloud, IA, analyse)</li>
      <li>des partenaires strictement nécessaires au fonctionnement du service</li>
      <li>des autorités administratives si la loi l&apos;exige</li>
    </ul>
    <p>Tous nos partenaires sont soumis à des obligations contractuelles strictes de confidentialité et de sécurité.</p>

    <hr />

    <h3>6. IA, modèles et amélioration du service</h3>
    <p>Les contenus fournis (CV, réponses, feedbacks) peuvent être utilisés de manière :</p>
    <ul>
      <li>
        <strong>anonymisée ou pseudonymisée</strong>
      </li>
      <li>à des fins d&apos;amélioration des algorithmes et de la qualité du service</li>
    </ul>
    <p>Aucune donnée nominative n&apos;est utilisée pour entraîner des modèles accessibles à des tiers.</p>

    <hr />

    <h3>7. Cookies et technologies similaires</h3>
    <p>The Patch utilise des cookies nécessaires au fonctionnement du site et, le cas échéant, des cookies analytiques.</p>
    <p>Vous pouvez gérer vos préférences via votre navigateur ou un bandeau cookies dédié.</p>

    <hr />

    <h3>8. Connexions via réseaux sociaux</h3>
    <p>Si vous choisissez de vous inscrire via un service tiers (Google, LinkedIn, etc.), nous collectons uniquement les informations strictement nécessaires à l&apos;authentification.</p>
    <p>Nous ne contrôlons pas les pratiques de ces plateformes : nous vous invitons à consulter leurs politiques de confidentialité respectives.</p>

    <hr />

    <h3>9. Durée de conservation des données</h3>
    <ul>
      <li>Données actives : conservées tant que votre compte est actif</li>
      <li>
        Compte supprimé : suppression ou anonymisation dans un délai maximum de <strong>6 mois</strong>
      </li>
      <li>
        Inactivité prolongée : suppression après <strong>3 ans sans connexion</strong>, sauf instruction contraire
      </li>
    </ul>
    <p>Certaines données peuvent être conservées plus longtemps si la loi l&apos;exige.</p>

    <hr />

    <h3>10. Données des mineurs</h3>
    <p>
      The Patch est réservé aux personnes âgées de <strong>18 ans minimum</strong>.
    </p>
    <p>Nous ne collectons pas sciemment de données concernant des mineurs.</p>
    <p>Si un tel cas est identifié, les données seront supprimées sans délai.</p>

    <hr />

    <h3>11. Vos droits</h3>
    <p>Conformément au RGPD, vous disposez notamment des droits suivants :</p>
    <ul>
      <li>droit d&apos;accès</li>
      <li>droit de rectification</li>
      <li>droit à l&apos;effacement</li>
      <li>droit à la limitation</li>
      <li>droit d&apos;opposition</li>
      <li>droit à la portabilité</li>
    </ul>
    {/* TODO(brand): keep prepwise.fr email temporarily; update after mailbox migration. */}
    <p>
      Pour exercer vos droits : <strong>contact@prepwise.fr</strong>
    </p>
    <p>Vous pouvez également introduire une réclamation auprès de l&apos;autorité de contrôle compétente (CNIL, Préposé fédéral suisse, etc.).</p>

    <hr />

    <h3>12. Do-Not-Track</h3>
    <p>À ce jour, The Patch ne répond pas aux signaux « Do-Not-Track », faute de standard universel reconnu.</p>

    <hr />

    <h3>13. Mise à jour de la politique</h3>
    <p>Cette politique peut être mise à jour à tout moment.</p>
    <p>En cas de modification substantielle, vous serez informé par email ou via la plateforme.</p>

    <hr />

    <h3>14. Responsable du traitement et contact</h3>
    <p>
      <strong>Responsable du traitement :</strong> Ilyas Redjem
    </p>
    {/* TODO(brand): keep prepwise.fr email temporarily; update after mailbox migration. */}
    <p>
      Email : <strong>ilyas@prepwise.fr</strong>
    </p>
  </>
);

export default FrContent;
